import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class completedQuestionnaireDataAccess {
  getGeneralInfo = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "CompletedQuestionnaire/get/general-info/" + params,
      {}
    );

    return result;
  };

  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "CompletedQuestionnaire/getall",
      parameters
    );
  };
}
export default new completedQuestionnaireDataAccess();
